import React from "react";
import { APPS } from "../../lib/constants";
import { AppIcon } from "./AppIcon";



export const AppGrid: React.FC = () => { 
  // Direct navigation functions for each app
  return (
    <div className="p-8">     
      {/* Regular app grid */}
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-8">
        {APPS.filter((i)=>i.showOnHome).map((app, index) => (
          <AppIcon key={app.id} app={app} index={index} />
        ))}
      </div>
    </div>
  );
};